export const PAGE_DETAILS = {
  rules: {
    title: 'Payment Orchestration Rules',
    description: 'List of the payment orchestration rules in the system',
  },
  dynamicRules: {
    title: 'Payment Orchestration Dynamic Rules',
    description:
      'List of the payment orchestration dynamic rules in the system',
  },
};

export const PAYMENT_ORCHESTRATION_RULE_STATUS = {
  ENABLED: 'Enabled',
  DISABLED: 'Disabled',
  FORCE_DISABLED: 'ForceDisabled',
};

export const WEIGHTAGE_TYPE_LIST = [
  { label: 'PERCENTAGE', value: 'PERCENTAGE' },
  { label: 'ABSOLUTE', value: 'ABSOLUTE' },
];

export const EFFICTIVITY_DATE_FORMAT = 'YYYY-MM-DD';

export const PAYMENT_ORCHESTRATION_RULE_DATE_TIME_FORMAT =
  'DD/MM/YYYY (hh:mm A)';

export const PAYMENT_ORCHESTRATION_RULE_DATE_FORMAT = 'DD/MM/YYYY';

export const PAYMENT_ORCHESTRATION_RULE_WEIGHTAGE_TYPE = {
  PERCENTAGE: 'PERCENTAGE',
  ABSOLUTE: 'ABSOLUTE',
};

export const COLUMN_WIDTH = {
  SM: 100,
  MD: 150,
  LG: 200,
  XL: 250,
  XXL: 350,
};

export const PAYMENT_ORCHESTRATION_RULE_COLUMNS = [
  { field: 'status', headerName: 'Status' },
  {
    field: 'source',
    headerName: 'Source',
    width: COLUMN_WIDTH.SM,
  },
  { field: 'monthlyCap', headerName: 'Monthly Cap' },
  {
    field: 'transactionRatio',
    headerName: 'Transaction Routing Ratio',
  },
  {
    field: 'weightageType',
    headerName: 'Weightage Type',
  },
  {
    field: 'currencyWeightage',
    headerName: 'Payment Currency Weightage',
  },
  { field: 'settlementMethod', headerName: 'Collection Method' },
  {
    field: 'effectiveStartDate',
    headerName: 'Effective Start Date',
  },
  {
    field: 'effectiveEndDate',
    headerName: 'Effective End Date',
  },
  { field: 'createdBy', headerName: 'Created By', width: COLUMN_WIDTH.XL },
  { field: 'modifiedBy', headerName: 'Modified By', width: COLUMN_WIDTH.XL },
];

export const DYNAMIC_RULES_EFFECTIVE_DATE_FORMAT = 'YYYY-MM-DD';

export const PAYMENT_ORCHESTRATION_DYNAMIC_RULES_COLUMNS = [
  { field: 'type', headerName: 'Type' },
  { field: 'subType', headerName: 'Subtype' },
  { field: 'conditions', headerName: 'Conditions', width: COLUMN_WIDTH.XXL },
  {
    field: 'effectiveStartDate',
    headerName: 'Effective Start Date',
  },
  {
    field: 'effectiveEndDate',
    headerName: 'Effective End Date',
  },
  { field: 'createdBy', headerName: 'Created By', width: COLUMN_WIDTH.XL },
  { field: 'modifiedBy', headerName: 'Modified By', width: COLUMN_WIDTH.XL },
];

export const DYNAMIC_RULE_TYPE_LIST = [
  { label: 'String', value: 'String' },
  { label: 'Date', value: 'Date' },
  { label: 'Boolean', value: 'Boolean' },
  { label: 'Big Decimal', value: 'BigDecimal' },
  { label: 'Integer', value: 'Integer' },
];

const OPERATOR_EQUAL_TO = { label: 'equal to', value: '=' };
const OPERATOR_NOT_EQUAL_TO = { label: 'not equal to', value: '!=' };
const OPERATOR_GREATER_THAN = { label: 'greater than', value: '>' };
const OPERATOR_LESS_THAN = { label: 'less than', value: '<' };
const OPERATOR_GREATER_THAN_EQUAL_TO = {
  label: 'greater than or equal to',
  value: '>=',
};
const OPERATOR_LESS_THAN_EQUAL_TO = {
  label: 'less than or equal to',
  value: '<=',
};

export const DYNAMIC_RULE_OPERATOR_LIST = {
  String: [OPERATOR_EQUAL_TO, OPERATOR_NOT_EQUAL_TO],
  Date: [
    OPERATOR_EQUAL_TO,
    OPERATOR_NOT_EQUAL_TO,
    OPERATOR_GREATER_THAN,
    OPERATOR_LESS_THAN,
    OPERATOR_GREATER_THAN_EQUAL_TO,
    OPERATOR_LESS_THAN_EQUAL_TO,
  ],
  Boolean: [OPERATOR_EQUAL_TO, OPERATOR_NOT_EQUAL_TO],
  BigDecimal: [
    OPERATOR_EQUAL_TO,
    OPERATOR_NOT_EQUAL_TO,
    OPERATOR_GREATER_THAN,
    OPERATOR_LESS_THAN,
    OPERATOR_GREATER_THAN_EQUAL_TO,
    OPERATOR_LESS_THAN_EQUAL_TO,
  ],
  Integer: [
    OPERATOR_EQUAL_TO,
    OPERATOR_NOT_EQUAL_TO,
    OPERATOR_GREATER_THAN,
    OPERATOR_LESS_THAN,
    OPERATOR_GREATER_THAN_EQUAL_TO,
    OPERATOR_LESS_THAN_EQUAL_TO,
  ],
};
